<template>
    <main>
        <div class="header"></div>
        <div class="bg">
            <div class="top-box">
                <div class="title-box">
                    <div class="title"></div>
                    <div class="m-title"><div class="img"></div></div>
                    <div class="logo" style="display: none"></div>
                </div>
                <div class="logo-box">
                    <div class="box"></div>
                </div>
            </div>
            <div class="register-box">
                <div class="title">报名参会</div>
				<div class="clear item" data-name="company">
					<div class="left tit"><div class="middle"><i>*</i>公司名称</div></div>
					<div class="left input" v-click-outside="hiddenCompany">
						<input type="text" class="left in" :class="[error.company ? 'error' : '']" @blur="validate('company')" placeholder="公司名称" v-model="form.company" @input="selectCompany">
						<div class="validate">{{error.company}}</div>
						<div class="input-select" v-if="company_loading || company.length > 0" >
							<div class="select-options" v-if="!company_loading">
								<div class="item"  v-for="item in company" @click="chooseCompany(item)">{{item}}</div>
							</div>
							<div class="loading" v-else>
								<van-loading />
							</div>
						</div>
					</div>
				</div>
                <div class="clear item" data-name="username">
                    <div class="left tit"><div class="middle"><i>*</i>姓名</div></div>
                    <div class="left input">
                        <input type="text" class="left in" :class="[error.username ? 'error' : '']" @blur="validate('username')" placeholder="姓名" v-model="form.username" >
                        <div class="validate">{{error.username}}</div>
                    </div>
                </div>
                <div class="clear item" data-name="email">
                    <div class="left tit"><div class="middle"><i>*</i>邮箱</div></div>
                    <div class="left input">
                        <input type="email" class="left in" :class="[error.email ? 'error' : '']" @blur="validate('email')" placeholder="邮箱" v-model="form.email">
                        <div class="validate">{{error.email}}</div>
                    </div>
                </div>
                <div class="clear item" data-name="phone">
                    <div class="left tit"><div class="middle"><i>*</i>手机号</div></div>
                    <div class="left input">
                        <input type="text" class="left in" :class="[error.phone ? 'error' : '']" @blur="validate('phone')" placeholder="手机" v-model="form.phone" :readonly="is_new == 2 ? true : false">
                        <div class="validate">{{error.phone}}</div>
                    </div>
                </div>
                <!-- <div class="clear item item-select" data-name="rank">
                    <div class="left tit"><div class="middle"><i>*</i>职级</div></div>
                    <div class="left input" :class="[error.rank ? 'error' : '']">
                        <dell-select :option="select_option.rank" :value="form.rank" @setValue="setValue('rank',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.rank}}</div>
                </div>
                <div class="clear item item-select" data-name="position">
                    <div class="left tit"><div class="middle"><i>*</i>职能选型</div></div>
                    <div class="left input" :class="[error.position ? 'error' : '']">
                        <dell-select :option="select_option.position" :value="form.position" @setValue="setValue('position',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.position}}</div>
                </div>
                <div class="clear item item-check" data-name="rank_list" v-if="form.position">
                    <div class="left tit"><div class="middle"><i>*</i>职能</div></div>
                    <div class="left ll" v-for="i in rank_list" v-if="i.type == form.position">
                        <label v-for="(ii,vv) in i.list"><input type="checkbox" v-model="form.rank_list" name="rank_list" :value="ii"><i></i><span>{{ii}}</span></label>
                    </div>
                    <div class="validate">{{error.rank_list}}</div>
                </div> -->
                <div class="clear item item-select" data-name="position">
                    <div class="left tit"><div class="middle"><i>*</i>职务</div></div>
                    <div class="left input" :class="[error.position ? 'error' : '']">
                        <dell-select :option="select_option.position" :value="form.position" @setValue="setValue('position',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.position}}</div>
                </div>
                <div class="clear item-wrap" data-name="province">
                    <div class="clear item item-m item-left">
                        <div class="left tit"><div class="middle"><i>*</i>省份</div></div>
                        <div class="left input" :class="[error.province ? 'error' : '']">
                            <dell-select :option="province" :value="form.province" @setValue="setValue('province',$event)"></dell-select>
                        </div>
                        <div class="validate">{{error.province}}</div>
                    </div>
                    <div class="clear item item-m" data-name="city">
                        <div class="left tit"><div class="middle"><i>*</i>城市</div></div>
                        <div class="left input" :class="[error.city ? 'error' : '']">
                            <dell-select :option="city" :value="form.city" @setValue="setValue('city',$event)"></dell-select>
                        </div>
                        <div class="validate">{{error.city}}</div>
                    </div>
                </div>
                <div class="clear item item-select" data-name="industry">
                    <div class="left tit"><div class="middle"><i>*</i>行业</div></div>
                    <div class="left input" :class="[error.industry ? 'error' : '']">
                        <dell-select :option="select_option.industry" :value="form.industry" @setValue="setValue('industry',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.industry}}</div>
                </div>
				<div class="clear item item-select" data-name="identity" v-if="is_offline && assign_channel || !is_offline">
					<div class="left tit"><div class="middle"><i>*</i>您的参会身份</div></div>
					<div class="left input" :class="[error.identity ? 'error' : '']">
            <template v-if="is_offline">
              <dell-select :option="select_option.identity_offline" :value="form.identity"
                           @setValue="setValue('identity',$event)"></dell-select>
            </template>
            <template v-else>
              <dell-select :option="select_option.identity" :value="form.identity"
                           @setValue="setValue('identity',$event)"></dell-select>
            </template>
<!--						<template v-if="!assign_channel">-->
<!--							<dell-select :option="select_option.identity" :value="form.identity" @setValue="setValue('identity',$event)"></dell-select>-->
<!--						</template>-->
<!--						<template v-else><dell-select :option="select_option.identity2" :value="form.identity" @setValue="setValue('identity',$event)"></dell-select></template>-->
					</div>
					<div class="validate">{{error.identity}}</div>
				</div>
				<div class="clear item item-check" data-name="forum" v-if="is_offline && assign_channel || !is_offline">
					<div class="left tit"><div class="middle"><i>*</i>您感兴趣的论坛</div></div>
					<div class="left ll forum-list" :class="[form.identity === '合作伙伴' && (!is_offline) ? 'active' : '']">
<!--						<template v-if="!assign_channel">-->
							<template  v-if="form.identity === '合作伙伴'&& (!is_offline)">
								<div class="li" v-for="(item,index) in select_option.forum2" :class="[checkForum(item) ? 'active' : '']" @click="chooseForum(item)">
									<div class="text" v-html="item.title"></div>
									<div class="text">({{item.time}})</div>
									<div class="desc">{{item.desc}}</div>
                  <div class="tips" v-if="item.tips && is_offline">{{ item.tips }}</div>
								</div>
							</template>
<!--							<template  v-else-if="form.identity === '戴尔员工'">-->
<!--								<div class="li" v-for="(item,index) in select_option.forum3" :class="[checkForum(item) ? 'active' : '']" @click="chooseForum(item)">-->
<!--									<div class="text" v-html="item.title"></div>-->
<!--									<div class="text">({{item.time}})</div>-->
<!--									<div class="desc">{{item.desc}}</div>-->
<!--								</div>-->
<!--							</template>-->
							<template v-else >
								<div class="li" v-for="(item,index) in select_option.forum" :class="[checkForum(item) ? 'active' : '']" @click="chooseForum(item)">
									<div class="text" v-html="item.title"></div>
									<div class="text">({{item.time}})</div>
									<div class="desc">{{item.desc}}</div>
								</div>
							</template>
<!--						</template>-->
<!--						<template v-else>-->
<!--							<div class="li" v-for="(item,index) in select_option.forum4" :class="[checkForum(item) ? 'active' : '']" @click="chooseForum(item)">-->
<!--								<div class="text" v-html="item.title"></div>-->
<!--								<div class="text">({{item.time}})</div>-->
<!--								<div class="desc">{{item.desc}}</div>-->
<!--							</div>-->
<!--						</template>-->
					</div>
					<div class="validate">{{error.forum}}</div>
				</div>
                <!-- <div class="clear item item-check" data-name="forum">
                    <div class="left tit"><div class="middle"><i>*</i>您感兴趣的论坛</div></div>
                    <div class="left ll" >
                        <label v-for="(item,index) in select_option.forum" ><input type="checkbox" v-model="form.forum" name="forum" :value="item"><i></i><span>{{item}}</span></label>
                    </div>
                    <div class="validate">{{error.forum}}</div>
                </div> -->
                <!--<div class="clear item item-select" data-name="people">
                    <div class="left tit"><div class="middle"><i>*</i>公司人数</div></div>
                    <div class="left input" :class="[error.people ? 'error' : '']">
                        <dell-select :option="select_option.people" :value="form.people" @setValue="setValue('people',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.people}}</div>
                </div>
                <div class="clear item item-select item-lang">
                    <div class="left tit"><div class="middle"><i>*</i>贵公司目前是否有采购IT产品的计划</div></div>
                    <div class="left input" :class="[error.plan ? 'error' : '']">
                        <dell-select :option="select_option.plan" :value="form.plan" @setValue="setValue('plan',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.plan}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="buy">
                    <div class="left tit"><div class="middle"><i>*</i>您的预算</div></div>
                    <div class="left input" :class="[error.buy ? 'error' : '']">
                        <dell-select :option="select_option.buy" :value="form.buy" @setValue="setValue('buy',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.buy}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="product">
                    <div class="left tit"><div class="middle"><i>*</i>您感兴趣的产品</div></div>
                    <div class="left input" :class="[error.product ? 'error' : '']">
                        <dell-select :option="select_option.product" :value="form.product" @setValue="setValue('product',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.product}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="case">
                    <div class="left tit"><div class="middle"><i>*</i>您感兴趣的解决方案</div></div>
                    <div class="left input" :class="[error.case ? 'error' : '']">
                        <dell-select :option="select_option.case" :value="form.case" @setValue="setValue('case',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.case}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="role">
                    <div class="left tit"><div class="middle"><i>*</i>您在公司的决策中扮演什么样的角色</div></div>
                    <div class="left input" :class="[error.role ? 'error' : '']">
                        <dell-select :option="select_option.role" :value="form.role" @setValue="setValue('role',$event)"></dell-select>
                    </div>
                    <div class="validate">{{error.role}}</div>
                </div>
                <div class="clear item item-select item-lang" data-name="description">
                    <div class="left tit"><div class="middle">项目描述</div></div>
                    <div class="left input">
                        <input type="text" class="left in" placeholder="项目描述" v-model="form.description">
                    </div>
                    <div class="validate"></div>
                </div>-->
                <!-- <div class="check-box item-select">
                    <div class="tit"><i class="red">*</i>更多解决方案或产品方面的问题，您是否愿意接受戴尔易安信销售/合作伙伴与您联系？</div>
                    <div class="check">
                        <label><input type="radio" v-model="form.agree_contact" name="receive_message" value="1"><i></i><span>是</span></label>
                        <label><input type="radio" v-model="form.agree_contact" name="receive_message" value="2"><i></i><span>否</span></label>
                    </div>
                    <div class="validate">{{error.agree_contact}}</div>
                </div> -->
				<div class="rule-box item-select" data-name="rule">
					<div class="tit">
						<label><input type="checkbox" @change="validate('rule')" v-model="form.rule" name="agree"><i class="i"></i>
              <span>我同意Dell Technology及其公司集团（简称”戴尔“）通过电子邮件、电话或短信与我保持联系。戴尔将及时向您通报有关产品、服务、解决方案、专属优惠和特别活动的最新信息。有关信息处理方式的更多详细信息，请阅读戴尔的<a href='https://www.dell.com/learn/cn/zh/cncorp1/policies-privacy' target="_blank" rel="noopener noreferrer"><i>&nbsp;隐私声明&nbsp;</i> </a>。您可以随时取消订阅。</span>
						</label>
					</div>
					<div class="validate">{{error.rule}}</div>
				</div>
                <div class="submit" @click="submit">立即报名</div>
            </div>
        </div>
        <div class="book-success" v-if="book_success">
            <div class="mark"></div>
            <div class="content">
				<div class="close" @click="toBack"></div>
				<div class="middle">
					<div class="title">{{book_info.title}}</div>
					<div class="m-title" v-html="book_info.desc"></div>
          <div class="qrcode-box">
            <template v-if="is_offline">
              <img src="@/assets/image/2024/qrcode01.jpg" alt="" class="qrcode">
              <div class="info">关注享多重好礼<br/>好礼一：申领大会资料<br/>好礼二：免费抽奖，100%中</div>
            </template>
            <template v-else>
              <img src="@/assets/image/2024/qrcode01.jpg" alt="" class="qrcode">
              <div class="info">关注享多重好礼<br/>好礼一：直播预约通知<br/>好礼二：申领大会资料<br/>好礼三：免费抽奖，100%中</div>
            </template>
          </div>
					<template v-if="is_offline">
						<div class="btn-group">
              <div class="btn" @click="toBack">确定</div>
<!--							<div class="btn btn-l" @click="toShenzhen">了解 9月8日 深圳站</div>-->
<!--							<div class="btn btn-l" @click="toShanghai">了解 9月28日 上海站</div>-->
						</div>
					</template>
					<template v-else>
						<div class="btn-group">
							<div class="btn" @click="toBack">确定</div>
						</div>
					</template>
				</div>
            </div>
        </div>
        <service></service>
    </main>
</template>

<script>
    import DellSelect from"../../components/pc/DellSelect";
    import Service from "../../components/pc/Service";
	import util from "@/common/util";
	import {companySelect} from "@/data/api";
	import {Loading as VanLoading} from "vant";
    export default {
        name:'edm',
        data() {
            return {
                query:"",
                form:{
					phone:"",
                    province:"",
                    agree_contact:'是',
                    position:"",
                    rank_list:[],
                    forum:[],
                    ifWish:"是"
                },
				company:[],
				company_loading:false,
				timeout:false,
                province:[],
                city:[],
                code_text:"获取验证码",
                code_status:true,
                is_new:2,
                error:{},
                book_success:false,
                book_info: {
                  title: "您已报名",
                  desc: "期待您在2026年08月21日参加 <br/>破局者  智行合璧 | 2026戴尔科技峰会"
                },
                logo:[require('@/assets/image/49.png'),require('@/assets/image/50.png')],
            }
        },
        components:{
            DellSelect,Service,VanLoading
        },
        computed:{
            select_option(){
                return {
                    // rank:["高级管理层","管理层","工程师/技术专家","其他"],
                    // position:["信息技术","高级行政","财务/采购","生产运维","办公室行政","客服/技术支持","媒体/出版","其他"],
					position:["CxO及以上","IT总监或IT负责人","IT经理或IT技术人员","业务负责人","设计/研发部门人员","IT采购人员/负责人","行政人员","其他职位"],

					industry:["互联网相关企业","IT服务业","物流运输业","其他服务行业","高科技制造业","普通制造业","金融行业","批发零售业","电信","媒体、娱乐","能源","政府、事业单位","医疗行业","教育行业","房地产","其他"],
					people:['1-25','26-99','100-499','500-999','1000-4999','5000-9999','10000+'],
					plan:['<3 月','3-6 月','6-12 月','>12 月',"无计划"],
					buy:["5万以下","5万-10万","10万-30万","30万-50万","50万-100万","100万以上","无计划"],
					product:["商用笔记本","商用台式机","工作站","服务器","网络交换机","数据存储","数据保护","超融合架构","显示器及外设设备"],
					case:["云计算","软件定义","大数据","融合/超融合","数据库加速","高性能计算","业务连续性","桌面虚拟化","数据保护","咨询服务","VR解决方案","灵活桌面解决方案","移动办公解决方案","智能会议解决方案","戴尔硬盘保护套件",],
					role:["决策者","影响者","建议者",],
          identity: ["客户", "合作伙伴", "戴尔员工", "媒体", "分论坛演讲嘉宾", "赞助商"],
          identity_offline: ["客户", "合作伙伴", "展区工作人员", "媒体", "分论坛演讲嘉宾", "赞助商"],
					identity2:["客户","戴尔员工","媒体", "分论坛演讲嘉宾"],
          forum: [
            {
              title: "AI 赋能“新智”生产力",
              time: "14:00-17:00",
              desc: "基于新一代人工智能设备，AI就绪方案引领工作场所变革"
            },
            {
              title: "AI 赋能数据，驱动绿色智能发展",
              time: "14:00-17:00",
              desc: "将人工智能引入数据策略，全面数据驱动和智能化，您需要构建一个全栈AI平台，它将整合以下要素，包括专注于数据、AI优化的基础设施、开放生态系统、专业服务和最佳实践。"
            }
          ],
          forum2: [
            {
              title: "主会场-进化 乘势而上",
              time: "9:00-12:00",
              desc: "2026年戴尔科技峰会暨Al-First领导力论坛，以“万物问新智行合璧”为主题的盛会。本次会议深入探讨企业在创新，人工智能布局和数字化转型方面的重要议题，与同行进行深入交流和学习,让全球各地创新者和智者相互连接,共同探索未来的商机与发展趋势。"
            },
            {
              title: "合作伙伴峰会",
              time: "14:00-17:50",
              desc: "我们将与您分享在新AI时代，戴尔科技集团One Channel渠道团队新架构，伙伴优先战略新规划，数字合伙人3.0发布新助力,与合作伙伴双向奔赴,携手共赢。本次大会将有特邀嘉宾及权威渠道生态咨询公司为大家分亨行业趋势，机遇洞察，打造完整的渠道生态体系更好地服务客户。",
              tips: "* 仅限戴尔官方授权合作伙伴参会，席位有限，先到先得"
            }
          ],
					forum3:[
						{
							title:"存储创新·现代化技术论坛",
							time:"14:00-17:05",
							desc:"欢迎进入持续现代化的、软件驱动型存储的新阶段。戴尔科技集团在整个存储产品组合中积极提供软件技术创新，如突破性的效率提升、增强的网络弹性和多云的灵活性。"
						},
						{
							title:"AI增效·智赢未来",
							time:"14:00-16:50",
							desc:"新型工作场景下，员工可以更加自由地选择工作方式，有利于他们激发创造力并更高效地开展工作。但这同时也对智能终端设备的智能性和安全性、企业IT架构的稳定性和可靠性，以及IT架构的灵活性和可扩展性提出新的要求。具有数实结合远见及能力的企业，以人为本，部署灵活的工作模式，打破传统生产边界，打造混合生产模式，增强生产力韧性，才能在保证高效工作效率的同时，让企业更好地适应未来。"
						},
						{
							title:"云数融合·现代化数据基础架构",
							time:"14:00-16:00",
							desc:"当数字化转型迈向深水区，大模型、物联网、云原生等新技术得到大量应用，业务场景日益多元，分散在边缘、核心、云的需求和应用爆炸性增长，灵活且可靠的IT基础架构底座变得尤为重要，快速部署，降本增效。"
						},
						{
							title:"数实融合·人工智能及边缘创新应用",
							time:"14:00-16:00",
							desc:"数字经济的加速深化催生了数字化需求结构变化，IT领域也在不断谋求以数字化创新和韧性提升核心竞争力。戴尔联合众多全球合作伙伴，提供从边缘应用、数据收集、边缘计算与分析、实时分析、数据维护到流数据的端到端解决方案，打造完整的跨边缘、核心和云的解决方案组合，并支持开放生态系统中的各种边缘工作负载，锻造韧性且创新的IT基石，坚持绿色低碳的绿色发展之路。"
						},
						{
							title:"合作伙伴峰会",
							time:"14:00-17:30",
							desc:"本次峰会将以“合力共赢 数实双昇”为主题，在数字化迅猛发展及全球经济动荡背景下，我们主张合力共赢的伙伴合作方向及模式，共同用数字化赋能，秉承数字合伙人精神，破圈整合赋能共创，助力客户，产业数实双昇。"
						}
					],
					forum4:[
						{
							title:"云数融合·现代化数据基础架构",
							time:"14:00-16:00",
							desc:"当数字化转型迈向深水区，大模型、物联网、云原生等新技术得到大量应用，业务场景日益多元，分散在边缘、核心、云的需求和应用爆炸性增长，灵活且可靠的IT基础架构底座变得尤为重要，快速部署，降本增效。"
						},
						{
							title:"AI增效·智赢未来",
							time:"14:00-16:50",
							desc:"新型工作场景下，员工可以更加自由地选择工作方式，有利于他们激发创造力并更高效地开展工作。但这同时也对智能终端设备的智能性和安全性、企业IT架构的稳定性和可靠性，以及IT架构的灵活性和可扩展性提出新的要求。具有数实结合远见及能力的企业，以人为本，部署灵活的工作模式，打破传统生产边界，打造混合生产模式，增强生产力韧性，才能在保证高效工作效率的同时，让企业更好地适应未来。"
						},
						{
							title:"数实融合·人工智能及边缘创新应用",
							time:"14:00-16:00",
							desc:"数字经济的加速深化催生了数字化需求结构变化，IT领域也在不断谋求以数字化创新和韧性提升核心竞争力。戴尔联合众多全球合作伙伴，提供从边缘应用、数据收集、边缘计算与分析、实时分析、数据维护到流数据的端到端解决方案，打造完整的跨边缘、核心和云的解决方案组合，并支持开放生态系统中的各种边缘工作负载，锻造韧性且创新的IT基石，坚持绿色低碳的绿色发展之路。"
						}
					]
                }
            },
            rank_list(){
                return [
					{type:"信息技术",list:['硬件管理及维护', '网络管理及维护', '桌面运维', 'IT架构设计', '应用软件研发', '软件管理/维护', '信息安全/保护/灾备', 'DBA/数据库', '数据中心/数据中台', '数据建模/挖掘/分析', '大数据架构', '项目管理', 'BI/商业智能', '人工智能', '通讯', '其他']},
					{type:"高级行政",list:['董事会', 'CEO', '总裁', '总经理', '其他']},
					{type:"财务/采购",list:['财务', '采购', '供应商管理', '其他']},
					{type:"生产运维",list:['供应链管理', '产线管理', '质量监控', '其他']},
					{type:"办公室行政",list:['办公室主任', '总裁助理/总经理助理/董事会秘书', '行政总监/经理', '其他']},
					{type:"客服/技术支持",list:['售前技术支持', '售后技术支持', '实施顾问', '咨询热线/呼叫中心', '客户服务', '其他']},
					{type:"媒体/出版",list:['编辑', '记者', '出版发行', '其他']},
					{type:"其他",list:['其他']},
                ]
            },
            form_province(){
                return this.form.province;
            },
            form_position(){
                return this.form.position;
            },
            form_rank_list(){
                return this.form.rank_list;
            },
            form_forum(){
                return this.form.forum;
            },
            form_agree_contact(){
                return this.form.agree_contact
            },
          channel() {
            return this.tool.storage.getLocal("channel") || "";
          },
			assign_channel(){
        const channel = this.tool.other.getUrlParams('channel');
        if (channel) {
          return channel.indexOf('sh-offline') != -1;
        } else {
          return true;
        }
			},
			is_offline(){
				return this.util.isOffline();
			},
        },
        watch:{
            form_position(){
                this.form.rank_list = [];
            },
            form_rank_list(){
                this.validate('rank_list');
            },
            form_forum(){
                this.validate('forum');
            },
            form_agree_contact(){
                this.validate('agree_contact');
            }
        },
        methods: {
			toShenzhen(){
				window.open('https://www.dellemc-solution.com/u/w1trqn4','_blank')
			},
			toShanghai(){
				window.open('https://www.dellemc-solution.com/u/lqduwe3','_blank')
			},
			checkForum(item){
				return this.form.forum.indexOf(item.title) > -1;
			},
			chooseForum(item){
				if(this.checkForum(item)){
					const index = this.form.forum.indexOf(item.title);
					this.form.forum.splice(index,1)
				}else{
					this.form.forum.push(item.title);
				}
			},
			hiddenCompany(){
				this.company = [];
			},
			selectCompany(){
				if(!this.form.company || this.form.company.length <= 1){
					return false;
				}
				this.company_loading = true;
				var wait = 500;
				if(!this.timeout){
					this.timeout = setTimeout(()=>{
						this.timeout = null;
						companySelect(this.form.company).then((res)=>{
							this.company = res.company;
						}).finally(()=>{
							this.company_loading = false;
						})
					},wait)
				}
			},
			chooseCompany(item){
				this.form.company = item;
				this.hiddenCompany();
			},
            getEdmByPhone(){
                if(!this.is_new){
                    this.setError('code','验证码错误');return false;
                }
                if(this.is_new == 1){return false;}
                if(this.validate('phone') && this.validate('code')){
                    this.http.request({
                        api:"auth/getEdmByPhone",
                        data:{
                            phone:this.form.phone,
                            code:this.form.code
                        },
                        loading:true,
                        success:(res)=>{
                            var user_thumb = res.user;
                            this.setThumbUser(user_thumb);
                        },
                        error:(res)=>{
                            if(res.msg == '已报名'){
                                this.book_info = {
									title:"您已报名",
									desc:this.is_offline ? "期待您在2026年08月21日参加 <br/>破局者  智行合璧 | 2026戴尔科技峰会" : "期待您在2026年08月21日参加 <br/>破局者  智行合璧 | 2026戴尔科技峰会",
                                }
                                this.book_success = true;
                                this.util.setAccessToken(res.data.access_token);
                                this.http.request({
                                    api:'user/getUserInfo',
                                    success:(res)=>{
                                        // 登录用户变量
                                        var gioParams = {
                                            // area_ppl: (res.user.province + res.user.city) || "",//省份,城市
                                            // companyName_ppl: res.user.company || "",//公司名称
                                            // companyScale_ppl: "",//公司规模
                                            // email_ppl: res.user.email || "",//邮箱
                                            // industry_ppl: res.user.job || "",//行业
                                            // phone_ppl: res.user.phone || "",//手机
                                            // userName_ppl: res.user.username || "",//姓名
                                            // userRole_ppl: "",//职位
                                        };
                                        gio('people.set',gioParams);
                                        //登录用户ID
                                        gio('setUserId', res.user.id);
                                        //登录用户类型
                                        gio('track', 'loginSuccess', {
                                            'user_Id': res.user.memberId,  // memberId
                                            'phoneNumber':util.encryptPhone(res.user.phone),  //登录手机号
                                            'loginType': '短信' // 短信或账号 密码登录的为“账号” 短信验证码登录的为“短信”
                                        })
                                        this.$store.commit('setUserInfo',res.user);
                                        this.util.setDellCookie();
                                    }
                                })
                            }else{
                                this.$toast.fail(res.msg);
                            }
                        }
                    })
                }
            },
            setThumbUser(user_thumb){
                if(!user_thumb){return false;}
                this.form.username = user_thumb.name;
                this.form.phone = user_thumb.mobile;
                this.form.email = user_thumb.email;
                this.form.company = user_thumb.enterprise_name;
                //this.form.rank = user_thumb.joblevel ? user_thumb.joblevel[0] :'';
                this.form.position = user_thumb.jobfunction ? user_thumb.jobfunction[0] :'';
                this.form.province = user_thumb.province && user_thumb.province[0] ?{title: user_thumb.province[0]} :'';
                this.form.city = user_thumb.province && user_thumb.province[1] ? {title:user_thumb.province[1]} : '';
                this.form.industry = user_thumb.industry ? user_thumb.industry[0] : '';
                //this.form.people = user_thumb.employeesNumber ? user_thumb.employeesNumber[0] :'';
                //this.form.plan = user_thumb.m_buyPlan ? user_thumb.m_buyPlan[0] : '';
                //this.form.buy = user_thumb.m_buyBudget ? user_thumb.m_buyBudget[0] : '';
                //this.form.product = user_thumb.m_interestProduct ? user_thumb.m_interestProduct[0] : '';
                //this.form.case = user_thumb.m_solutionType ? user_thumb.m_solutionType[0] : '';
                //this.form.role = user_thumb.m_companyRole ? user_thumb.m_companyRole[0] : '';
                //this.form.description = user_thumb.m_isummary;

                this.form.password = user_thumb.password;
                this.form.memberId = user_thumb.memberId;
                this.form.loginId = user_thumb.loginId;
                this.form.session = user_thumb.session;
                this.form.sess = user_thumb.sess;

              if (this.form.position) {
                if (this.select_option.position.indexOf(this.form.position) == -1) {
                  this.form.position = "";
                }
              }
              if (this.form.industry) {
                if (this.select_option.industry.indexOf(this.form.industry) == -1) {
                  this.form.industry = "";
                }
              }
                this.$forceUpdate();
                this.$nextTick(()=>{
                    this.form.rank_list = user_thumb.jobfunctionrole && this.tool.type.isArray(user_thumb.jobfunctionrole) ? user_thumb.jobfunctionrole[0].split(',') : [];
                    this.$forceUpdate();
                    this.error = {};
                })
            },
            validate(field,name = ""){
                var message = "";
                switch (field) {
                    case 'phone':
                        if(!this.form.phone){
                            message = "请输入手机号";
                        }else if(this.isCn() && !this.tool.type.checkStr(this.form.phone,'phone') ){
                            message = "请输入正确的手机号";
                        }else{
                            message = "";
                        }
                        break;
                    case 'code':
                        if(!this.form.code){
                            message = "请输入验证码";
                        }else if(this.form.code.length != 6){
                            message = '验证码不正确';
                        }else{
                            message = "";
                        }
                        break;
                    case 'username':
                        if(!this.form.username){
                            message = "请输入姓名";
                        }else{
                            message = "";
                        }
                        break;
                    case 'email':
                        if(!this.form.email){
                            message = "请输入邮箱";
                        }else if(!this.tool.type.checkStr(this.form.email,'email')){
                            message = "请输入正确的邮箱";
                        }else{
                            message = "";
                        }
                        break;
                    case 'password':
                        if(!this.form.password){
                            message = "请输入密码";
                        }else if(this.form.password.length < 6){
                            message = "请输入6-20个字符";
                        }else{
                            message = "";
                        }
                        break;
                    case 'password2':
                        if(!this.form.password2){
                            message = "请再次确认密码";
                        }else if(this.form.password !== this.form.password2){
                            message = "两次输入的密码不一致";
                        }else{
                            message = "";
                        }
                        break;
                    case 'company':
                        if(!this.form.company){
                            message = "请输入公司名称";
                        }else{
                            message = "";
                        }
                        break;
                    case 'select':
                        if(!this.form[name]){
                            message = "请选择";
                        }else{
                            message = "";
                        }
                        break;
                    case 'rule':
                        if(!this.form.rule){
                            message = "请先阅读并同意戴尔隐私声明和销售条款";
                        }else{
                            message = "";
                        }
                        break;
                    case 'agree_contact':
                        if(!this.form.agree_contact){
                            message = "请选择";
                        }else{
                            message = "";
                        }
                        break;
                    case 'rank_list':
                        if(this.form.rank_list && this.form.rank_list.length <= 0){
                            message = "请选择";
                        }else{
                            message = "";
                        }
                        break;
                    case 'forum':
                        if(this.form.forum && this.form.forum.length <= 0){
                            message = "请选择您感兴趣的论坛";
                        }else{
                            message = "";
                        }
                        break;
                    default:
                        break;
                }
                this.setError(name ? name : field,message);
                return message ? false : true;
            },
            validateAll(){
                var phone = this.validate("phone");
                var code = this.validate('code');
                var username = this.validate('username');
                var email = this.validate('email');
                var password = this.validate('password');
                var password2 = this.validate('password2');
                var company = this.validate('company');
                var rank = this.validate('select','rank');
                var position = this.validate('select','position');
                var rank_list = this.validate('rank_list');
                var province = this.validate('select','province');
                var city = this.validate('select','city');
                var industry = this.validate('select','industry');
                var people = this.validate('select','people');
                var plan = this.validate('select','plan');
                var buy = this.validate('select','buy');
                var product = this.validate('select','product');
                var cases = this.validate('select','case');
                var identity = this.validate('select','identity');
                var forum = this.validate('forum');
                var role = this.validate('select','role')
                var agree_contact = this.validate('agree_contact')
                var rule = this.validate('rule')
                if(this.is_new == 2){
                  let isV = !company || !username || !email || !phone || !rule || !position || !province || !city || !industry;
                  if (this.is_offline && this.assign_channel || !this.is_offline) {
                    isV = !company || !username || !email || !phone || !rule || !position || !province || !city || !industry || !identity || !forum;
                  }
                    //if(!phone || !username || !email || !company || !province || !rank || !position || !rank_list || !city || !industry || !people || !plan || !buy || !product || !cases || !role || !rule ){
                    if(isV){
                        this.$nextTick(()=>{
                            this.scrollError();
                        })

                        return false;
                    }else{
                        return true;
                    }
                }else{
                  let isV = !company || !username || !email || !phone || !rule || !position || !province || !city || !industry;
                  if (this.is_offline && this.assign_channel || !this.is_offline) {
                    isV = !company || !username || !email || !phone || !rule || !position || !province || !city || !industry || !identity || !forum;
                  }
                    if(isV){
                        this.$nextTick(()=>{
                            this.scrollError();
                        })
                        return false;
                    }else{
                        return true;
                    }
                }
            },
            scrollError(){
                var list = $('.validate');
                for(var i =0;i<list.length;i++){
                    if($(list[i]).text().length > 0){
                        $('body,html').scrollTop($(list[i]).parent().offset().top-100)
                        break;
                    }
                }
            },
            setError(name,message =""){
                this.error[name] = message;
                this.$forceUpdate();
            },
            submit(){
                var form = this.form;
                form.province_title = this.form.province ? this.form.province.title : '';
                form.city_title = this.form.city ? this.form.city.title :'';
                form.url = window.location.href;
                form.guest_id = this.util.getGuestUid();

                if(this.tool.storage.getLocal('channel')){
                    form.channel = this.tool.storage.getLocal('channel');
                }
                form.huiyileixing = this.util.isOffline() ? '线下会' : '线上会';

                var res = this.validateAll();
                if(!res){return false;}

                var api = "auth/registerForEn";
                if(this.isCn()){
                    api = "auth/register";
                }

                gio('track', 'DTF2021_SignupSubmit', {
                    // 'userName':form.username,
                    // 'phoneNumber':form.phone,
                    // 'company' : form.company,
                    // 'email' :form.email,
                });

                this.http.request({
                    api:api,
                    data:form,
                    loading:true,
                    success:(res)=>{
                        this.util.setAccessToken(res.access_token);
                        this.getUserInfo();
                    },
                    error:(res)=>{
                        this.$toast.fail(res.msg);
                    }
                })
            },
            getUserInfo(){
                this.http.request({
                    api:'user/getUserInfo',
                    loading:true,
                    success:(res)=>{
                        this.$store.commit('setUserInfo',res.user);
                        this.util.setDellCookie();
                        this.toBack();
                    }
                })
            },
            toBack(){
              this.util.toLink('/invitation');
              // this.util.toBack();
            },
            setValue(key,value){
                this.form[key] = value;
                if(key == 'province'){
                    this.form.city = "";
                    this.city = [];
                    if(value){
                        this.getCity();
                    }
                }
                this.validate('select',key);
                this.$forceUpdate();
            },
            getProvince(){
                this.http.request({
                    api:"area/dell_province",
                    success:(res)=>{
                        this.province = res.province;
                    }
                })
            },
            getCity(){
                this.http.request({
                    api:"area/dell_city",
                    data:{
                        province_id:this.form.province.id
                    },
                    success:(res)=>{
                        this.city = res.city;
                    }
                })
            },
            checkNewUser(callback){
                var phone = this.validate("phone");
                if(!phone){return false;}
                this.http.request({
                    api:"user/checkNewUser",
                    data:{
                        phone:this.form.phone,
                        guest_id:this.util.getGuestUid()
                    },
                    //loading:true,
                    success:(res)=>{
                        this.is_new = res.is_new;
                        callback.call();
                    }
                })
            },
            getCode(){
                if(!this.code_status){return false;}
                var phone = this.validate("phone");
                if(!phone){
                    return  false;
                }

                this.cutTime();
                this.checkNewUser(()=>{
                    if(!this.is_new){return false;}

                    var api = "sms/registerForEn";
                    if(this.isCn()){
                        api = "sms/register"
                    }
                    if(this.is_new == 2){
                        api = "sms/loginForEn";
                        if(this.isCn()){
                            api = "sms/login"
                        }
                    }
                    this.http.request({
                        api:api,
                        data:{
                            phone:this.form.phone
                        },
                        //loading:true,
                        success:(res)=>{
                            //this.cutTime();
                        },
                        error:(res)=>{
                            this.setError('phone',res.msg)
                            clearInterval(this.timer);
                            this.code_text = "获取验证码"
                            this.code_status = true;
                        }
                    })
                });
            },
            cutTime(){
                this.code_status = false;
                var number = 59;
                this.code_text = "重新获取("+number+"s)";
                this.timer = setInterval(()=>{
                    number = number -1;
                    if(number <= 0){
                        clearInterval(this.timer);
                        this.code_text = "获取验证码"
                        this.code_status = true;
                    }else{
                        this.code_text = "重新获取("+number+"s)";
                    }
                },1000)
            },
            isCn(){
                return true;
            }
        },
        mounted() {
            var user_thumb = this.$store.state.user_thumb;
            if(!user_thumb.loginId){
                this.$router.replace({
                    path:"/login"
                })
            }
            this.query = this.$route.query;
            this.getProvince();
            this.setThumbUser(user_thumb);
            this.util.showBottom(true);
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .header{position: fixed;top:0;left:0;width: 100%;height:80px;text-align: center;color: #fff;border-bottom: 1px solid rgba(255,255,255,.2);z-index: 99;background: url("~@/assets/image/2024/bmbg01.png") no-repeat center top;background-size: 100%;}
    .bg{background:#1a56c6 url("~@/assets/image/2024/bmbg01.png") no-repeat top center;background-size:100% ;padding-bottom: 50px;
        .top-box{text-align: center;
            .title-box{display: inline-block; padding-top:80px;text-align: left;color: #fff;position: relative;
                .title{width: 740px;height:400px;background: url("~@/assets/image/2024/kv02.png") no-repeat center center;background-size: contain;margin-top:-50px;margin-left: -45px;}
                .m-title{display:none;width: 970px;margin-top:-110px;
                    .img{width:431px;height:30px;background: url("../../assets/image/83_2.png") no-repeat center center;background-size:contain;float: left;}
                }
                .logo{position: absolute;bottom:0;right:20px;width: 272px;height:33px;background: url("~@/assets/image/logo.png") no-repeat center center;background-size: contain;}
            }
            .logo-box{width: 960px;color: #fff;text-align: left;opacity: 0;
                .box{width: 240px;height:34px;background: url("~@/assets/image/82.png") no-repeat center center;background-size: contain; }
            }
        }
        .register-box{width: 960px;background: #fff;margin: 10px auto 0;border-radius: 5px;padding-bottom: 50px;
            .title{height:70px;line-height: 70px;text-align: center;font-size: 18px;border-bottom: 2px solid #f6f6f6;position: relative;margin-bottom: 34px;}
            .title::after{content:"";position: absolute; display: block;bottom:-2px;left:50%;width: 150px;height:4px;margin-left: -75px;background: #175cc6;}
            .item-wrap{clear: both;
                .validate{margin-left:110px;}
            }
            .item{width: 830px;margin: 0 auto;
                .tit{ width: 120px;padding-right: 10px;font-size: 14px;line-height: 20px;
                    .middle{height:40px; width: 120px;text-align: right;
                        i{color: #ff0000;margin-right: 2px;}
                    }
                }
                .input{width: 630px;position: relative;
                    .in{display: block; width: 600px;height:40px;padding: 0 15px;font-size: 14px; border-radius: 5px;background: #fafafa;border: 1px solid #f1f1f1;}
                    .in.error{border-color: red;}
					.input-select{position: absolute;left:0;top:40px;width: 100%;height:200px;overflow: hidden;overflow-y: auto;z-index: 99;background: #fff;border: 1px solid #f1f1f1;
						.select-options{
							.item{height:40px;line-height: 40px;padding: 0 14px;overflow: hidden}
							.item:hover,.item.active{background: #fafafa;}
						}
						.loading{display: flex;height:100%;position: relative; justify-content: center;align-items: center;}
					}
                }
                .input.error{border: 1px solid red;box-sizing: border-box;border-radius: 5px;}
                .input.code{
                    .in{width: 440px;}
                    .btn{display: block;float: right; width: 150px;font-size: 14px;border-radius: 5px;text-align: center;line-height: 42px;background: #41b6e6;color:#fff;cursor: pointer;}
                    .btn.hidden{background: #999999;}
                }
                .validate{clear: both; height:30px;line-height: 30px;font-size:14px;color:red;}
            }
            .item.item-check{
                .ll{width: 630px;padding-top: 5px;
                    label{display: block;float: left; margin-right: 30px;height:30px;line-height: 30px;cursor: pointer;
                        input{margin-right:5px;display: none;}
                        span{display: block;float: left;}
                        input[type=checkbox]+i{display: block;float: left;width: 30px;height:30px;background: url("~@/assets/image/a4.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        input[type=checkbox]:checked+i{background: url("~@/assets/image/a3.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                    }
                }
                .validate{margin-left:130px;}
				.forum-list{display: flex;flex-wrap: wrap;
					.li{width: calc((100% - 12px)/2); margin-right: 12px;margin-bottom: 12px; padding: 12px;border: 1px solid #666666;border-radius: 10px;box-sizing: border-box;cursor: pointer;
						.text{font-weight: bold;font-size: 16px;white-space: pre-wrap;}
						.desc{margin-top: 5px;font-size: 14px;}
            .tips {
              margin-top: 5px;
              font-size: 14px;
              color: #0076ce;
            }
					}
					.li.active{border-color: #175cc6;background: #175cc6;color:#fff;}
					.li:nth-last-child(1){width: 100%;margin-right: 0;}
					.li:nth-child(2n){margin-right: 0;width: calc((100% - 12px)/2); }
				}
				.forum-list.active{display: block;
					.li{width: 100%;margin-right: 0;}
				}
            }
            .item.error{
                .input{
                    .in{border-color: red;}
                }
            }
            .item.item-m{float: left;width:375px;
                .tit{width: 105px;}
                .input{width:250px;
                    .in{width: 230px;}
                }
            }
            .item.item-m.item-left{padding-left:80px;}
            .item.item-select{
                .validate{margin-left:130px;}
            }
            .item.item-lang{
                .tit{float: none;width: 100%;margin-left: 130px;
                    .middle{width: 100%;height:30px;}
                }
                .input{float: none;margin-left: 130px;}
                .validate{}
            }
            .check-box{padding-left: 80px; width: 640px;margin: 0 auto 0;
                .tit{font-size: 15px;line-height: 21px;
                    .red{color:red;margin-right: 2px;}
                }
                .check{overflow: hidden;margin-top: 10px;
                    label{margin-right: 50px;height:30px;line-height: 30px;cursor: pointer;overflow: hidden;display: block;float: left;
                        input{margin-right:10px;width: 18px;height:18px;float: left;margin-top: 5px;display: none;}
                        input[type=radio]+i{display: block;float: left; width: 30px;height:30px;background: url("~@/assets/image/a2.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        input[type=radio]:checked+i{background: url("~@/assets/image/a1.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                        span{display: block;float: left;}
                    }
                }
                .validate{clear: both; height:30px;line-height: 30px;font-size:14px;color:red;}
            }
            .rule-box{padding-left: 80px; width: 640px;margin: 0 auto 24px;
                .tit{font-size: 15px;line-height: 30px;overflow: hidden;
                    input{margin-right: 5px;cursor: pointer;width: 18px;height:18px;margin-top: 5px; float: left;display:none;}
                    span{display: block;float: left;width: 600px;}
                    i{color:#175cc6;text-decoration: underline !important;cursor: pointer;}
                    input[type=checkbox]+.i{display: block;float: left;width: 30px;height:30px;background: url("~@/assets/image/a4.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                    input[type=checkbox]:checked+.i{background: url("~@/assets/image/2024/check1.png") no-repeat center center;background-size: 22px;transition: all .3s ease;}
                    .red{color:red;text-decoration: none !important;cursor: default;margin-right: 2px;}
                }
                .validate{clear: both;padding-left: 30px; height:30px;line-height: 30px;font-size:14px;color:red;}
            }
			.submit{width:362px;margin: 30px auto ;height:45px;line-height: 45px;text-align: center;color: #fff;font-size: 18px; background: #175cc6;border-radius: 5px;box-shadow: 0 0 10px 5px rgba(1,118,206,.1);cursor: pointer;transition: all .3s ease;}
			.submit:hover{color: rgb(200,200,200);transition: all .3s ease;}
        }
    }
	//.book-success{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 1000;
	//	.mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8);}
	//	.content{position: absolute;left:50%;top:50%;width:750px;height:390px;background: url("~@/assets/image/2026/bg-success.png") no-repeat center center;background-size: cover;color: #fff;margin-left:-375px;margin-top:-195px;border-radius: 10px;
	//		.close{width: 50px;height:50px;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size: 20px;cursor: pointer;transition: background .3s ease;}
	//		.close:hover{background-image:url("~@/assets/image/53.png");background-size: 20px; transition: background .3s ease;}
	//		.middle{width: 750px;height:390px;text-align: center;color:#232846;
	//			.title{font-size: 34px;font-weight: bold;}
	//			.m-title{font-size: 24px;margin-top: 15px;line-height: 1.5;}
	//			.qrcode-box{display: flex;justify-content: center;align-items: center;margin-top: 20px;
	//				.qrcode{width: 130px;height:130px;display: block;}
	//				.info{font-size: 22px;margin-left: 15px;text-align: left;}
	//			}
	//			.btn-group{display: flex;align-items: center;justify-content: center;margin-top: 20px;
	//				.btn{margin-right: 100px;}
	//				.btn:nth-last-child(1){margin-right: 0;}
	//			}
	//			.btn{width:140px;height:50px;text-align: center;line-height:50px;color:#fff;cursor: pointer;border-radius: 5px;background: #ec6014}
	//			.btn.btn-l{width: 160px;}
	//		}
	//	}
	//}
    .book-success {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1000;

      .mark {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .8);
      }

      .content {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 750px;
        height: 390px;
        background: url("~@/assets/image/2024/bmbg02.png") no-repeat center center;
        background-size: cover;
        color: #fff;
        margin-left: -375px;
        margin-top: -195px;
        border-radius: 10px;

        .close {
          width: 50px;
          height: 50px;
          position: absolute;
          top: 0;
          right: 0;
          background: url("~@/assets/image/54.png") no-repeat center center;
          background-size: 20px;
          cursor: pointer;
          transition: background .3s ease;
        }

        .close:hover {
          background-image: url("~@/assets/image/53.png");
          background-size: 20px;
          transition: background .3s ease;
        }

        .middle {
          width: 750px;
          height: 390px;
          text-align: center;
          color: #ffffff;

          .title {
            font-size: 34px;
            font-weight: bold;
          }

          .m-title {
            font-size: 20px;
            margin-top: 15px;
            line-height: 1.5;
          }

          .qrcode-box {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;

            .qrcode {
              width: 130px;
              height: 130px;
              display: block;
            }

            .info {
              font-size: 20px;
              margin-left: 15px;
              text-align: left;
            }
          }

          .btn-group {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;

            .btn {
              margin-right: 100px;
            }

            .btn:nth-last-child(1) {
              margin-right: 0;
            }
          }

          .btn {
            width: 140px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            color: #0b32a9;
            cursor: pointer;
            border-radius: 5px;
            background: #3bcfda;
            font-size: 20px;
          }

          .btn.btn-l {
            width: 160px;
          }
        }
      }
    }
</style>

